import './App.css';
import About from './Component/About';
import Contact from './Component/Contact';
import Header from './Component/header';
import { Main } from './Component/Main';
import Services from './Component/Services';
import Skills from './Component/Skills';
import Stars from './Component/stars';
import Work from './Component/Work';
import './Media/Media.css'

function App() {

  return (
    <div className='item'>
      <div className='header-width'>
        <Header />
      </div>
      <div className='content'>
        <Main />
        <Stars />
        <Work />
        <About />
        <Services />
        <Skills />
        <Contact />
        
      </div>
    </div>
  );
}

export default App;
